import React from "react";
import {field, Loader, utils} from "@mc/mc-legacy";
import {connect} from "react-redux";
import * as textNoteActions from "../../actions/textNoteActions";
import PropTypes from "prop-types";

type Props = {
    items: any,
}

class TextNoteField extends React.Component<Props> {

    static propTypes = {
        onTextNoteChange: PropTypes.func,
    };

    componentDidMount() {
        this.fetchData(true);
    }

    UNSAFE_componentWillReceiveProps() {
        this.fetchData();
    }

    fetchData = (force = false) => {
        this.props.dispatch(textNoteActions.fetchTextNotesIfNeeded(force));
    };

    render() {
        const {dispatch, onChange, onTextNoteChange, textNoteList, ...componentProps} = this.props;

        if (textNoteList.fetching) {
            return <Loader/>;
        }

        return (
            <field.Autocomplete
                {...componentProps}
                getItemName={(item) => (item ? item.note : "")}
                items={textNoteList.rows}
                onChange={(data) => {
                    if (onTextNoteChange) {
                        onTextNoteChange(data);
                    }
                }}
            />
        );
    }
}

export default connect((state) => {
    return {
        textNoteList: utils.storeFromArea(state, textNoteActions.TEXT_NOTE_LIST),
    };
})(TextNoteField);
